import { Box, Container, Grid } from '@mui/material';
import { Heading1 } from 'components/v2/common/Heading1';
import achievementFlag from 'assets/images/achievementFlag.svg';
import donate from 'assets/images/donate.svg';
import idea from 'assets/images/idea.svg';
import peopleGroup from 'assets/images/peopleGroup.svg';
import like from 'assets/images/like.svg';
import { Element } from './Element';
import { Carousel } from 'react-responsive-carousel';
import chevronRight from 'assets/images/chevronRight.svg';

export const Achievements = () => {
  return (
    <Box bgcolor="#DAEFF1" component="section">
      <Box mx="auto" pt="44px" width="800px" maxWidth="90%">
        <Heading1 icon={achievementFlag.src}>POD Community in 2022</Heading1>
      </Box>
      <Container
        disableGutters
        sx={{
          display: {
            xs: 'none',
            md: 'inherit',
          },
        }}
      >
        <Grid container mt="54px" pb="40px">
          <Grid item lg={3} display="flex" justifyContent="center">
            <Element title="2000+" content="Investors" icon={peopleGroup.src} />
          </Grid>
          <Grid item lg={3} display="flex" justifyContent="center">
            <Element title="13 Funded" content="Startups" icon={idea.src} />
          </Grid>
          <Grid item lg={3} display="flex" justifyContent="center">
            <Element
              title="₹3 Crores"
              content="Funds Raised"
              icon={donate.src}
            />
          </Grid>
          <Grid item lg={3} display="flex" justifyContent="center">
            <Element title="2" content="Live Campaigns" icon={like.src} />
          </Grid>
        </Grid>
      </Container>
      <Box
        sx={{
          display: {
            xs: 'inherit',
            md: 'none',
          },
        }}
        pt={6}
        pb={8}
      >
        <Carousel
          showStatus={false}
          showThumbs={false}
          showIndicators={false}
          infiniteLoop
          renderArrowNext={(onClickHandler) => (
            <Box
              position="absolute"
              top="50%"
              sx={{
                transform: 'translate(0, -50%)',
                '& img': {
                  height: 14,
                },
              }}
              right={50}
              zIndex={20}
              onClick={onClickHandler}
              p={1}
            >
              <img src={chevronRight.src} alt="arrow right" />
            </Box>
          )}
          renderArrowPrev={(onClickHandler) => (
            <Box
              position="absolute"
              top="50%"
              sx={{
                transform: 'translate(0, -50%) scale(-1,1)',
                '& img': {
                  height: 14,
                },
              }}
              left={50}
              zIndex={20}
              onClick={onClickHandler}
              p={1}
            >
              <img src={chevronRight.src} alt="arrow right" />
            </Box>
          )}
        >
          <Box display="flex" justifyContent="center">
            <Element title="2000+" content="Investors" icon={peopleGroup.src} />
          </Box>
          <Box display="flex" justifyContent="center">
            <Element title="12 Startups" content="Funded" icon={idea.src} />
          </Box>
          <Box display="flex" justifyContent="center">
            <Element title="₹3 Cr." content="Funds Raised" icon={like.src} />
          </Box>
          <Box display="flex" justifyContent="center">
            <Element title="1" content="Live Campaigns" icon={donate.src} />
          </Box>
        </Carousel>
      </Box>
    </Box>
  );
};
